<template>
  <div>
    <v-app-bar
      height="64px"
      :style="{ paddingLeft: !$vuetify.breakpoint.xs }"
      dense
      dark
      app
      clipped-left
    >
      <template v-if="$vuetify.breakpoint.lgAndUp">
        <v-app-bar-nav-icon
          data-test="menu"
          @click="toggle"
        ></v-app-bar-nav-icon>

        <v-toolbar-title class="logo-offset text-center">
          <router-link to="/">
            <img src="@/assets/logo.svg" alt="logo" class="main-logo" />
          </router-link>
        </v-toolbar-title>

        <div
          class="d-flex justify-center"
          style="width: 100%; position:relative;"
        >
          <v-combobox
            data-test-main-search
            :menu-props="{ closeOnContentClick: true, closeOnClick: true }"
            key="desktopField"
            class="mr-3"
            style="max-width: 690px"
            append-icon=""
            v-model="selected"
            @keydown.enter="filterTable"
            @click:clear="onClear"
            return-object
            :search-input.sync="searchQuery"
            hide-details
            no-filter
            solo
            maxlength="1000"
            text
            :items="preparedItems"
            :loading="isLoading"
            item-text="name"
            clearable
            item-value="id"
            prepend-inner-icon="mdi-magnify"
            background-color="#474747"
            placeholder="Search"
          >
            <template v-slot:item="{ item }">
              <template
                v-if="
                  item.id === 'divider' &&
                    searchedListCurrent.length &&
                    searchedListOther.length
                "
              >
                <v-divider />
              </template>
              <template v-else>
                <v-list-item
                  :data-test-search-item="item.name"
                  @click.prevent="goToCard(item)"
                >
                  <v-list-item-avatar>
                    <v-icon>{{ getIcon(item.type) }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
          </v-combobox>
        </div>

        <v-spacer />
      </template>
      <template v-else-if="$vuetify.breakpoint.smAndUp">
        <div style="width: 382px; position: relative">
          <v-combobox
            key="mobileField"
            @keydown.enter="filterTable"
            :menu-props="{
              closeOnContentClick: true,
              maxHeight: 220,
              closeOnClick: true
            }"
            style="max-width: 100%"
            solo
            text
            data-test-search
            label="Search"
            background-color="#474747"
            placeholder="Search"
            :items="preparedItems"
            :loading="isLoading"
            item-text="name"
            item-value="id"
            append-icon=""
            v-model="selected"
            maxlength="1000"
            return-object
            :search-input.sync="searchQuery"
            hide-details
            hide-no-data
            no-filter
          >
            <template v-slot:prepend-inner>
              <v-app-bar-nav-icon
                data-test="menu"
                @click.stop="toggle"
              ></v-app-bar-nav-icon>
            </template>
            <template v-slot:append>
              <v-btn
                icon
                v-if="searchQuery && searchQuery.length > 0"
                @click="onClear"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn disabled icon v-else>
                <v-icon>mdi-camera</v-icon>
              </v-btn>
            </template>
            <template v-slot:item="{ item }">
              <template
                v-if="
                  item.id === 'divider' &&
                    searchedListCurrent.length &&
                    searchedListOther.length
                "
              >
                <v-divider />
              </template>
              <template v-else>
                <v-list-item
                  :data-test-search-item="item.name"
                  @click="goToCard(item)"
                >
                  <v-list-item-avatar>
                    <v-icon>{{ getIcon(item.type) }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
          </v-combobox>
        </div>

        <v-spacer />
      </template>
      <template v-else-if="$vuetify.breakpoint.xs">
        <v-combobox
          @keydown.enter="filterTable"
          :menu-props="{
            closeOnContentClick: true,
            bottom: true,
            offsetY: true,
            maxHeight: 220,
            closeOnClick: true
          }"
          class="main-search-m"
          key="xsField"
          solo
          data-test-search
          text
          maxlength="1000"
          :items="preparedItems"
          :loading="isLoading"
          item-text="name"
          item-value="id"
          append-icon=""
          v-model="selected"
          return-object
          :search-input.sync="searchQuery"
          hide-details
          no-filter
          label="Search"
          hide-no-data
          background-color="#474747"
          placeholder="Search"
        >
          <template v-slot:prepend-inner>
            <v-app-bar-nav-icon
              data-test="menu"
              @click.stop="toggle"
            ></v-app-bar-nav-icon>
          </template>
          <template v-slot:append>
            <div style="width: 100px;"></div>
          </template>
          <template v-slot:item="{ item }">
            <template
              v-if="
                item.id === 'divider' &&
                  searchedListCurrent.length &&
                  searchedListOther.length
              "
            >
              <v-divider />
            </template>
            <template v-else>
              <v-list-item
                :data-test-search-item="item.name"
                @click="goToCard(item)"
              >
                <v-list-item-avatar>
                  <v-icon>{{ getIcon(item.type) }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </v-combobox>
        <div class="main-search-m__actions-btn">
          <v-btn
            icon
            v-if="searchQuery && searchQuery.length > 0"
            @click="onClear"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn disabled icon v-else>
            <v-icon>mdi-camera</v-icon>
          </v-btn>
          <div class="divider-actions"></div>
          <notifications />
        </div>
      </template>
      <template v-if="$vuetify.breakpoint.smAndUp">
        <time-widget />
        <notifications />
        <app-select />
        <v-menu offset-y :nudge-bottom="12" @input="handleInputMenu">
          <template v-slot:activator="{ on }">
            <v-btn
              data-test="userMenu"
              fab
              small
              color="primary"
              class="avatar-action"
              v-on="on"
              style="text-transform: uppercase; overflow: hidden;"
            >
              <v-img
                cover
                v-if="getPicture"
                width="40"
                height="40"
                :src="getPicture"
              />
              <span v-else>
                {{ firstLetters }}
              </span>
            </v-btn>
          </template>
          <menu-user @show-popup="showPopupMethod" />
        </v-menu>
      </template>
    </v-app-bar>
    <popup2 v-model="showPopup" width="428">
      <component
        v-if="showPopup"
        :profile="currentProfile"
        :entity="entity"
        :is="action"
        @close="showPopup = false"
        @save="save"
      />
    </popup2>
  </div>
</template>

<script>
import useSearches from '@/api/searches';
import useAuth from '@/api/auth';
import useUsers from '@/api/users';

import notifications from './Notifications.vue';
import moment from 'moment';
import MenuUser from '../menu/MenuUser';

import userEdit from '@/components/app-entity/modals/CreateUser.vue';
import {
  computed,
  onMounted,
  reactive,
  toRefs,
  watch
} from '@vue/composition-api';
import AppSelect from '@/layouts/LayoutDefault/app-bar/AppSelect';
import TimeWidget from '@/layouts/LayoutDefault/app-bar/TimeWidget.vue';
export default {
  name: 'AppBar',
  components: {
    TimeWidget,
    AppSelect,
    userEdit: () => import('@/components/app-entity/modals/CreateUser.vue'),
    MenuUser,
    notifications,
    notySettings: () => import('../popups/NotificationSettings'),
    programSettings: () => import('../popups/ProgramSettings'),
    menuSettings: () => import('../popups/MenuSettings')
  },
  setup(props, { root }) {
    const state = reactive({
      entity: null,
      inited: false,
      showPopup: false,
      action: null,
      searchQuery: '',
      debounceId: null,
      searches: [],
      selected: null,
      isLoading: false,
      items: [],
      currentProfile: null
    });

    const api = new useSearches();
    const auth = useAuth();
    const userApi = new useUsers().user;
    const mapFilter = {
      device: 'device',
      dataset: 'dataset',
      media: 'media',
      Schema: 'schemas',
      application: 'applications',
      User: 'users',
      Notification: 'notifications',
      'User Group': 'groups'
    };

    const mapFilterHumanReadable = {
      device: 'devices',
      dataset: 'datasets',
      media: 'medias',
      Schema: 'schemas',
      application: 'applications',
      User: 'users',
      Notification: 'notifications',
      'User Group': 'groups'
    };

    const getIcon = type => {
      switch (type) {
        case 'device':
          return 'mdi-memory';
        case 'media':
          return 'mdi-image';
        case 'dataset':
          return 'mdi-puzzle';
        case 'User':
          return 'mdi-account';
        case 'preset':
          return 'mdi-clipboard-text-play-outline';
        case 'Notification':
          return 'mdi-message-text';
        case 'Schema':
          return 'mdi-card-bulleted';
        case 'application':
          return 'mdi-application-cog';
        case 'User Group':
          return 'mdi-account-supervisor';
      }
    };
    const getFilter = () => {
      let filter = '';
      const matched = root.$route.matched.map(i => i.path);
      if (matched.includes('/devices')) {
        filter = 'device';
      }
      if (matched.includes('/datasets')) {
        filter = 'dataset';
      }
      if (matched.includes('/medias')) {
        filter = 'media';
      }
      if (matched.includes('/schemas')) {
        filter = 'Schema';
      }
      if (matched.includes('/apps')) {
        filter = 'application';
      }
      if (matched.includes('/users/all')) {
        filter = 'User';
      }
      if (matched.includes('/users') && !matched.includes('/all')) {
        filter = 'User Group';
      }
      if (matched.includes('/notifications')) {
        filter = 'Notification';
      }
      return filter;
    };
    const showPopupMethod = (e, data) => {
      console.log(e);
      state.currentProfile = e?.payload;
      state.showPopup = true;
      state.action = e?.name || e;
      state.entity = currentUser.value;
    };
    const onClear = () => {
      root.$router
        .replace({
          query: {
            keyword: null,
            filterTable: '',
            nestedId: root.$route.query.nestedId
          }
        })
        .catch(e => {});
      state.selected = null;
      state.searchQuery = '';
      state.searches = [];
    };
    const filterTable = () => {
      root.$router.replace({
        query: {
          keyword: state.searchQuery,
          filterTable: state.searchQuery
        }
      });

      state.searches = [];
    };
    const save = data => {
      switch (state.action) {
        case 'userEdit': {
          userApi.update(data.id, data).then(() => {
            state.showPopup = false;
            state.action = null;
            auth.loadUser().then(r => {
              auth.user.value = r;
            });
          });
        }
      }
    };
    const convertDate = v => {
      return moment(new Date(v)).format('D MMMM YYYY, H:mm:ss');
    };
    const getStatusIcon = v => {
      switch (v) {
        case 'no_response':
          return 'alert-circle';
        case 'low_battery':
          return 'battery-alert';
        case 'is_active':
          return 'check-circle';
      }
    };
    const toggle = e => {
      root.$store.dispatch('menu/toggle');
    };
    const setNotifications = () => {
      root.$store.commit('notifications/set');
    };

    const currentUser = computed(() => {
      return auth.user.value;
    });
    const notifications = computed(() => {
      return root.$store.state.notifications.data;
    });
    const searchedListCurrent = computed(() => {
      const filter = getFilter();
      const res = state.searches[mapFilter[filter]] || [];
      return res;
    });
    const searchedListOther = computed(() => {
      const filter = getFilter();
      const res = Object.values(state.searches)
        .flat(1)
        .filter(i => i.type !== filter);
      // if (res.length > 3) {
      //   res.length = 3;
      // }
      return res;
    });
    const getPicture = computed(() => {
      if (auth.user.value?.mIcon) {
        return `${window.__pixelConfig.APP_MEDIA_SERVER}/download/${
          auth.user.value?.mIcon
        }/${localStorage.getItem('authToken')}`;
      } else {
        return '';
      }
    });
    const firstLetters = computed(() => {
      if (auth.user.value?.login) {
        const r = auth.user.value.login.split(' ');
        return r.length > 1
          ? `${r[0][0]}${r[1][0]}`.toUpperCase()
          : `${r[0][0]}`.toUpperCase();
      }
      return 'UN';
    });
    const goToCard = async item => {
      state.selected = {
        type: item.type,
        id: item.id,
        name: item.name
      };
      if (state.selected) {
        await root.$nextTick();
        switch (state.selected.type) {
          case 'User':
            root.$router.push({
              name: 'usersTableComponent',
              params: {
                id: state.selected.id,
                groupId: 'all'
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'device':
            root.$router.push({
              name: 'devicesTableComponent',
              params: {
                id: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'application':
            root.$router.push({
              name: 'appsTableComponent',
              params: {
                id: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'media':
            root.$router.push({
              name: 'mediasTableComponent',
              params: {
                id: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'dataset':
            root.$router.push({
              name: 'datasetsTableComponent',
              params: {
                id: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'Schema':
            root.$router.push({
              name: 'schemasTableComponent',
              params: {
                id: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'User Group':
            root.$router.push({
              name: 'users',
              params: {
                groupId: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
          case 'Notification':
            root.$router.push({
              name: 'notificationsTableComponent',
              params: {
                id: state.selected.id
              },
              query: { keyword: state.searchQuery }
            });
            break;
        }
      }
    };
    const preparedItems = computed(() => {
      const filter = getFilter();

      if (searchedListOther.value.length && searchedListCurrent.value.length) {
        return [
          {
            header:
              searchedListCurrent.value.length >= 5
                ? `Showing up to 5 first results in ${mapFilterHumanReadable[filter]} section`
                : `Showing all results in ${mapFilterHumanReadable[filter]} section`
          },
          ...searchedListCurrent.value,
          { id: 'divider', disabled: true },
          {
            header:
              searchedListOther.value.length >= 5
                ? 'Showing up to 5 first results from other sections'
                : 'Showing all results from other sections'
          },
          ...searchedListOther.value
        ];
      } else if (searchedListCurrent.value.length > 0) {
        return [
          {
            header:
              searchedListCurrent.value.length >= 5
                ? `Showing up to 5 first results in ${mapFilterHumanReadable[filter]} section`
                : `Showing all results in ${mapFilterHumanReadable[filter]} section`
          },
          ...searchedListCurrent.value
        ];
      }
      return [...searchedListOther.value];
    });

    watch(
      () => state.searchQuery,
      async () => {
        if (state.inited && state.searchQuery) {
          // TODO: need rework
          // if (state.searchQuery) {
          //   await root.$nextTick();
          //   root.$router.replace({
          //     query: {
          //       keyword: state.searchQuery,
          //       filterTable: root.$route.query.filterTable
          //     }
          //   });
          // }
          clearInterval(state.debounceId);
          state.debounceId = setTimeout(() => {
            state.isLoading = true;
            api.searches
              .loadPure(state.searchQuery.trim())
              .then(r => (state.searches = r))
              .finally(() => (state.isLoading = false));
          }, 400);
        }
      }
    );

    onMounted(() => {
      if (root.$route.query && root.$route.query.keyword) {
        state.selected = root.$route.query.keyword;
      }
      root.$store.dispatch('notifications/load');
      root.$nextTick(() => {
        state.inited = true;
      });
    });

    const { loadProfileAsync } = useAuth();

    const handleInputMenu = e => {
      if (e) {
        loadProfileAsync();
      }
    };

    return {
      ...toRefs(state),
      getIcon,
      getFilter,
      showPopupMethod,
      onClear,
      filterTable,
      save,
      convertDate,
      getStatusIcon,
      toggle,
      setNotifications,
      currentUser,
      notifications,
      searchedListCurrent,
      searchedListOther,
      getPicture,
      firstLetters,
      preparedItems,
      goToCard,
      handleInputMenu
    };
  }
};
</script>

<style lang="sass">
.no_response,
.low_battery
  color: #D50000

.logo-text
  font-size: 24px

.logo-offset
  flex-shrink: 0

.avatar-action
  margin-left: 8px
  font-size: 16px

.main-logo
  display: block

.divider-actions
  width: 1px
  background: #fff
  margin: 10px
  height: 30px

.main-search-m
    position: relative
    &__menu-btn
      position: absolute
      left: 10px
      top: 4px
      z-index: 1
    &__actions-btn
      display: flex
      position: absolute
      right: 16px
      align-items: center

.main-search-m.v-text-field .v-input__append-outer
  margin-left: 0

.main-search-m.v-text-field .v-input__prepend-outer
  margin-right: 0
</style>
